import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../pages/card.css";
import { QRCodeCanvas } from "qrcode.react";
import { useCommonVars } from "./useCommonVars";
import axios from "../axiosInstance";
import ReactDOM from "react-dom";



function ToastPortal({ toast }) {
  if (!toast) return null;
  return ReactDOM.createPortal(
    <div className="toast-wrapper">
      <div className="toast-inner">{toast}</div>
    </div>,
    document.body
  );
}

function shortenAddress(address, start = 6, end = 4) {
  if (!address || address.length <= start + end) return address;
  return `${address.slice(0, start)}...${address.slice(-end)}`;
}




const formatTxId = (id, type) => {
  const letter = type === "withdraw" ? "W" : "D";
  return letter + id.toString().padStart(6, "0");
};

const formatDate = (isoString) => {
  const d = new Date(isoString);
  return d.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const getStatus = (tx) => {
  if (tx.type === "deposit") return "Успешно";
  if (tx.type === "withdraw") {
    switch (tx.status) {
      case "rejected":
        return "Отмена";
      case "approved":
        return "Успешно";
      default:
        return "В обработке";
    }
  }
  return "В обработке";
};

const getStatusClass = (label) => {
  switch (label) {
    case "Успешно":
      return "status-success";
    case "Отмена":
      return "status-cancel";
    case "В обработке":
    default:
      return "status-pending";
  }
};

const getTypeLabel = (tx) =>
  tx.type === "deposit" ? "Пополнение" : tx.type === "withdraw" ? "Вывод" : "";

const ids = {
  USDT: "tether",
  TON: "the-open-network",
  TRX: "tron",
  BTC: "bitcoin",
};

function CardPage({ user, userDetails, btc, usdt, ton, eth, bnb, logo }) {
  const presetAmounts = [
    { amount: 1000, percent: 0 },
    { amount: 2000, percent: 0 },
    { amount: 5000, percent: 0 },
    { amount: 10000, percent: 0 },
    { amount: 25000, percent: 0 },
    { amount: 35000, percent: 0 },
    { amount: 50000, percent: 0 },
    { amount: 75000, percent: 0 },
    { amount: 100000, percent: 0 },
  ];
  const {
    channelUrl,
    chatUrl,
    supportUrl,
    investPercent,
    cryptoWallets,
    minInvest,
  } = useCommonVars(user);
  const [depositInput, setDepositInput] = useState("");
  const [amount, setAmount] = useState("");
  const [daily, setDaily] = useState("0,00₽");
  const [weekly, setWeekly] = useState("0,00₽");
  const [monthly, setMonthly] = useState("0,00₽");
  const [yearly, setYearly] = useState("0,00₽");
  const [percentDisplay, setPercentDisplay] = useState(`${investPercent}%`);
  const [showDepositModal, setShowDepositModal] = useState(false);
  const [showCryptoModal, setShowCryptoModal] = useState(false);
  const [showCryptoPaymentModal, setShowCryptoPaymentModal] = useState(false);
  const [selectedCrypto, setSelectedCrypto] = useState("USDT");
  const [copySuccess, setCopySuccess] = useState(false);
  const [cryptoRates, setCryptoRates] = useState({});
  const [cryptoAmount, setCryptoAmount] = useState("");
  const copyTimeout = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.state?.openDepositModal) {
      setShowDepositModal(true);
    }
  }, [location.state]);
  useEffect(() => {
    const updateRates = async () => {
      try {
        const res = await fetch(
          `https://api.coingecko.com/api/v3/simple/price?ids=${ids.USDT},${ids.TON},${ids.TRX},${ids.BTC}&vs_currencies=rub`,
        );
        const data = await res.json();
        const rates = {
          USDT: data[ids.USDT].rub,
          TON: data[ids.TON].rub,
          TRX: data[ids.TRX].rub,
          BTC: data[ids.BTC].rub,
        };
        setCryptoRates(rates);
        localStorage.setItem(
          "cryptoRates",
          JSON.stringify({
            rates,
            updated: Date.now(),
          }),
        );
      } catch (err) {}
    };

    const saved = localStorage.getItem("cryptoRates");
    if (saved) {
      let parsed;
	  try { 
		  parsed = JSON.parse(saved); 
		} catch(e) { 
		  updateRates(); 
		  return; 
		}
      const { rates, updated } = parsed;
      const now = Date.now();
      if (now - (updated || 0) > 3600000) {
        updateRates();
      } else {
        setCryptoRates(rates);
      }
    } else {
      updateRates();
    }
  }, []);

  const [toast, setToast] = useState("");

  useEffect(() => {
	  if (location.state?.confirmMessage) {
		setToast(location.state.confirmMessage);
		navigate(location.pathname, { replace: true, state: {} });
	  }
	}, [location.state, location.pathname, navigate]);

  useEffect(() => {
	  if (toast) {
		const timer = setTimeout(() => setToast(""), 4000);
		return () => clearTimeout(timer);
	  }
	}, [toast]);

  useEffect(() => {
    const key = selectedCrypto === "USDT_BEP20" ? "USDT" : selectedCrypto;
    if (!depositInput || !cryptoRates[key]) {
      setCryptoAmount("0.00");
      return;
    }

    const decimals = key === "BTC" ? 6 : 2;
    const calculated = (parseFloat(depositInput) / cryptoRates[key]).toFixed(
      decimals,
    );
    setCryptoAmount(calculated);
  }, [depositInput, selectedCrypto, cryptoRates]);

  const cryptoOptions = {
    USDT: {
      address: cryptoWallets.USDT_TRON,
      label: "USDT (TRC-20)",
      short: "USDT",
    },
    TON: {
      address: cryptoWallets.TON,
      label: "TON (Toncoin)",
      short: "TON",
    },
    TRX: {
      address: cryptoWallets.TRON,
      label: "TRX (Tron)",
      short: "TRX",
    },
    BTC: {
      address: cryptoWallets.BTC,
      label: "BTC",
      short: "BTC",
    },
    USDT_BEP20: {
      address: cryptoWallets.USDT_BEP,
      label: "USDT (BEP-20)",
      short: "USDT",
    },
  };

  const handleChange = (e) => {
    const input = e.target.value.replace(/[^\d.]/g, "");
    setAmount(input);

    const value = parseFloat(input);
    if (value >= minInvest && value <= 10000000) {
      const day = value * (investPercent / 100);
      setDaily(day.toFixed(2) + "₽");
      setWeekly((day * 7).toFixed(2) + "₽");
      setMonthly((day * 30).toFixed(2) + "₽");
      setYearly((day * 365).toFixed(2) + "₽");
      setPercentDisplay(`${investPercent}%`);
    } else {
      setDaily("0,00₽");
      setWeekly("0,00₽");
      setMonthly("0,00₽");
      setYearly("0,00₽");
      setPercentDisplay("0%");
    }
  };

  const handleBankClick = () => {
    if (Number(depositInput) >= minInvest) {
      navigate("/bank-transfer", {
        state: { amount: depositInput, method: "card" },
      });
    } else {
      setToast(`Минимальная сумма пополнения: ${minInvest}₽`);
    }
  };
  const handleSbp2Click = () => {
	  if (Number(depositInput) >= minInvest) {
		navigate("/qr-transfer", {
		  state: { amount: depositInput, method: "nspk" }, 
		});
	  } else {
		setToast(`Минимальная сумма пополнения: ${minInvest}₽`);
	  }
	};
  const handlePAYEERClick = () => {
	  if (Number(depositInput) >= minInvest) {
		navigate("/payeer", {
		  state: { amount: depositInput, method: "payeer" }, 
		});
	  } else {
		setToast(`Минимальная сумма пополнения: ${minInvest}₽`);
	  }
	};
  const handleSbpClick = () => {
    if (Number(depositInput) >= minInvest) {
      navigate("/bank-transfer", {
        state: { amount: depositInput, method: "sbp" },
      });
    } else {
      setToast(`Минимальная сумма пополнения: ${minInvest}₽`);
    }
  };
  const handleOpenCryptoModal = () => {
	  const sum = Number(depositInput);
	  if (isNaN(sum) || sum < minInvest) {
		setToast(`Минимальная сумма пополнения: ${minInvest}₽`);
		return;
	  }
	  navigate("/crypto-deposit", { state: { amount: depositInput } });
	};

  const handleMouseDown = (e) => {
    const el = e.currentTarget;
    const rect = el.getBoundingClientRect();
    const clickX = e.clientX - rect.left;

    el.style.transform =
      clickX < rect.width / 2 ? "translateX(-2px)" : "translateX(2px)";
  };
  const combined = [
    ...(userDetails.investments || []).map((inv) => ({
      id: inv.id,
      type: "deposit",
      amount: inv.amount,
      timestamp: inv.created_at,
    })),
    ...(userDetails.withdrawal_requests || []).map((w) => ({
      id: w.id,
      type: "withdraw",
      amount: w.amount,
      timestamp: w.created_at,
      status: w.status,
    })),
  ];

  const recent = combined
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
    .slice(0, 10);
  const handleMouseUp = (e) => {
    e.currentTarget.style.transform = "";
  };
  const closeAllModals = () => {
    setShowCryptoPaymentModal(false);
    setShowCryptoModal(false);
    setShowDepositModal(false);
  };
  const [submitting, setSubmitting] = useState(false);
  const handleConfirm = async () => {
    if (!depositInput || !selectedCrypto) {
      setToast("Не все данные заполнены!");
      return;
    }
    setSubmitting(true);

    try {
      const payload = {
        user_id: user?.telegram_id,
        pay_id: "-",
        method: selectedCrypto,
        amount: depositInput,
      };

      if (cryptoAmount && cryptoAmount !== "0.00") {
        payload.crypto_amount = cryptoAmount;
      }
      if (cryptoOptions[selectedCrypto]?.short) {
        payload.crypto_code = cryptoOptions[selectedCrypto].short;
      }

      const res = await axios.post("/project/send-payment-message", payload, {
        withCredentials: true,
		headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (res.data?.status === "ok") {
        closeAllModals();
        navigate("/card", {
          state: {
            confirmMessage:
              "✅ Заявка отправлена. Ожидайте подтверждения администратора.",
          },
        });
      } else {
        setToast("❌ Не удалось отправить заявку. Повторите позже.");
      }
    } catch {
      setToast("⚠️ Ошибка при подтверждении. Попробуйте позже.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ToastPortal toast={toast} />
    <div className="main-container">
      <div className="deposit-cards">
	  <div className="deposit-card-balance-row">
		<span className="deposit-label">Ваш баланс</span>
	  </div>
	  <div className="deposit-balance-row">
		<span className="deposit-balance">
		  {userDetails?.balance !== undefined
			? userDetails.balance.toLocaleString("ru-RU", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			  }) + "₽"
			: "0,00₽"}
		</span>
	  </div>
	  <div className="deposit-buttons">
		<button className="btn-deposit" onClick={() => setShowDepositModal(true)}>
		  Пополнить
		</button>
		<button className="btn-withdraw" onClick={() => navigate("/withdraw")}>
		  Вывести
		</button>
	  </div>
	</div>


      <div className="profit-calculator">
        <div className="profit-title">Калькулятор прибыли</div>

        <input
          className="profit-input"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder={`Сумма (${minInvest} - 10,000,000)`}
          value={amount}
          onChange={handleChange}
        />

        <div className="profit-percent">{percentDisplay}</div>

        <div className="profit-box">
          <div className="label">День</div>
          <div className="value">{daily}</div>
        </div>

        <div className="profit-box">
          <div className="label">Неделя</div>
          <div className="value">{weekly}</div>
        </div>

        <div className="profit-box">
          <div className="label">Месяц</div>
          <div className="value">{monthly}</div>
        </div>

        <div className="profit-box">
          <div className="label">Год</div>
          <div className="value">{yearly}</div>
        </div>
      </div>
      <div className="recent-wrapper">
        <div className="recent-title">
          <span className="dot" /> Ваши последние операции
        </div>
        <div
          className={`recent-transactions${recent.length === 0 ? " empty" : ""}`}
        >
          {recent.length > 0 ? (
            <table className="tx-table">
              <thead>
                <tr>
                  <th>Номер транзакции</th>
                  <th>Сумма</th>
                  <th>Статус</th>
                  <th>Время</th>
                </tr>
              </thead>
              <tbody>
                {recent.map((tx) => {
                  const statusLabel = getStatus(tx);
                  const statusClass = getStatusClass(statusLabel);
                  const typeLabel = getTypeLabel(tx);
                  const amountFormatted =
                    Number(tx.amount).toLocaleString("ru-RU", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + "₽";

                  return (
                    <tr key={`${tx.id}-${tx.timestamp}`}>
                      <td className="tx-id">
                        <div>{formatTxId(tx.id, tx.type)}</div>
                        <div className="tx-type-label">{typeLabel}</div>
                      </td>
                      <td className="tx-amount">{amountFormatted}</td>
                      <td className={`tx-status ${statusClass}`}>
                        {statusLabel}
                      </td>
                      <td className="tx-time">{formatDate(tx.timestamp)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <>
              <div className="recent-placeholder no-transactions">
                Транзакций пока нет
              </div>
              <div className="recent-subtext">
                Начните инвестировать, чтобы увидеть историю операций!
              </div>
            </>
          )}
        </div>
      </div>

      <div className="info-section">
        <div className="info-title">Информация</div>
        <div className="info-support">
              <div className="support-links">
                <a href={supportUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Поддержка">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M4 15V11C4 6.582 7.582 3 12 3C16.418 3 20 6.582 20 11V15" stroke="currentColor" strokeWidth="2"/>
                      <rect x="2" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <rect x="17" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 21V19" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </span>
                  Поддержка
                </a>
                <span className="dot-sep">·</span>
                <a href={channelUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Канал">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 3L3 10.53L8.38 12.06L18.25 6.03C18.66 5.78 19.08 6.22 18.82 6.62L12.38 16.5V16.5L12.37 16.5L12.38 16.5V16.5L14.12 20.16C14.34 20.62 14.97 20.65 15.24 20.21L21 3Z" fill="currentColor"/>
                    </svg>
                  </span>
                  Канал
                </a>
                <span className="dot-sep">·</span>
                <a href={chatUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Чат">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 11.5C21 16.1944 16.9706 20 12 20C10.5709 20 9.22432 19.7453 8.02781 19.2929L3 20.5L4.20711 15.6725C3.44217 14.5208 3 13.0716 3 11.5C3 6.80558 7.02944 3 12 3C16.9706 3 21 6.80558 21 11.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  Чат
                </a>
              </div>
            </div>
        <div className="info-subtitle">Партнерская программа</div>
        <div className="info-icons-box">
          <img src={btc} alt="btc" className="coin-icon" />
          <img src={usdt} alt="usdt" className="coin-icon" />
          <img src={ton} alt="ton" className="coin-icon" />
          <img src={eth} alt="eth" className="coin-icon" />
        </div>
        <div className="copyright">© 2025 | Все права защищены.</div>
      </div>
      {showDepositModal && (
        <div className="modal-overlay">
          <div className="deposit-modal">
            <button
              className="modal-close"
              onClick={() => setShowDepositModal(false)}
            >
              ✕
            </button>
            <input
              className="deposit-amount-input"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="0₽"
              value={depositInput}
              onChange={(e) =>
                setDepositInput(e.target.value.replace(/[^\d]/g, ""))
              }
            />
            <div className="deposit-hint">
              Минимальная сумма пополнения: {minInvest}₽
            </div>

            <div className="preset-grid">
              {presetAmounts.map((item, index) => (
                <button
                  key={index}
                  className="preset-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDepositInput(() => item.amount.toString());
                  }}
                >
                  {item.amount}₽
                  <div className="percent-tag">
                    <span>+{item.percent}%</span>
                  </div>
                </button>
              ))}
            </div>
            {showCryptoModal && (
              <div
                className="modal-overlay"
                onClick={(e) => {
                  if (e.target.classList.contains("modal-overlay")) {
                    setShowCryptoModal(false);
                  }
                }}
              >
                <div className="crypto-select-window">
                  <button
                    className="modal-close-button"
                    onClick={() => setShowCryptoModal(false)}
                  >
                    ×
                  </button>
                  <div className="crypto-sum-bar">
                    <span className="crypto-sum-text">
                      Сумма пополнения: {depositInput || "0"}₽
                    </span>
                  </div>

                  <div className="crypto-subtitle">
                    ВЫБЕРИТЕ СПОСОБ ДЛЯ ПЕРЕВОДА
                  </div>

                  <div
                    className="crypto-option"
                    onMouseDown={handleMouseDown}
                    onMouseUp={(e) => {
					  handleMouseUp(e);
					  setSelectedCrypto("USDT");
					  setShowCryptoModal(false);
					  navigate("/crypto-payment", {
						state: { amount: depositInput, selectedCrypto: "USDT" },
					  });
					}}
                  >
                    <div className="crypto-ellipse">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          width="15"
                          height="15"
                          fill="url(#pattern0_1_694)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_1_694"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlinkHref="#image0_1_694"
                              transform="scale(0.00444444)"
                            />
                          </pattern>
                          <image
                            id="image0_1_694"
                            width="225"
                            height="225"
                            preserveAspectRatio="none"
                            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAKhQTFRFAAAA78jH67u65aWj4JSR2X161Gdkzk9LyTgzxy4oxiYhwxwXwhQNwQ8H6bKw89LR5rSz3ImH0lpWwQAAvwAAwQsAwQ0E67u63o+NxjIu5aSi1GRg1nFuyT06zlRQvQAA6bKw0l5a7cTCzEVB4ZmWzUtH13Z08tLR9+Tk/PX09N/f+u3t////+efm/PPy3IWC5rSz78jH89jX8tLR89LR7cTC/vr635+fWeBGCQAAADh0Uk5TAGb/////////////////J+b///////+5///////////5/4b/////J//////////////////////JBco2AAANWklEQVR4nOWd+XPbNhbHAR0kQFKyLKdrx0ldx0mTzh5Np7Mz/f9/3+1sp7NtvW0aN20Opz4lUpItkViA1EFJPIXHy/7+kOgyhY8Avgc8AA8YZS+8EH/MGGKeNJM/zv7bs7z4FmcaUe87mMBDQ/GQIgHpvYqGhCmj6wwLkRUh3r1VewQjVptxBUmwOvxDo/aNcppRfWZCuI/PdSxaZyjasqhorczaYe8yKAw44W4TD/hFawnhFqIOp9TY+BS4QLCE9UeWYW1ANxOn1E39rQ1ZJkDCw3ctzGoj2csQB7P+/glAgTyBETbbhoWl8TwRppu9Mcy1gAjrzV0wPE8c8nQM0lohCJtbiN0CXGdFCkbXABUpTYgP+xKmJVrc8LROZN2kJOERvs6MT4gzbrFfpS4hRXj0tsXqGfIJURv3H8kwShDmwSfEGbXG5oybEz4e5cInxBnJH5v+8aaEe2Oc5f23Kuqw5ofN/nQzQqxRWPcXL8KGg43M6kaEysNBznxCRLM3aaobEB728c0G3wQglbVOUv9RekK1lXcDXYiwfuofNy3hrkkLqkBP6tBIOYBMSdhsF9VCZ1JZylFHOkJi5OkigkUdM9VdkoZwl9kZDCHSS6njFC01BWGjU5yJWRZhV5PEH05OeICHhbfQmSjtXyT9bGJCqhdsYpalWkl/7oSEWw1UiltwIQVdJOvEJSMsrhsTrqQdnESEz67KYmP8IqzzS4KPJSEsjxFdVjLEBISNTvFuPljUSeA14gn3JmUFFIiN2HFxLOF2O7HnKULd3mXMJ+II9yalM6LLUuNqMYaw9IDxiNGE2/XSA8bei5GE+7flNTILUUeJmjuOIjzqldMProqwdkTAOIpwR366Mx8R5zz8zQhCjZassx0uZTgIfS+cUG2V38rMpYbH4EIJS+7pVxXu+cMID80K1aCQapwEvxFGWBkrM1OotQkhpFplrMxMyiDYdwcTPh5VrI0KqcFzjIGEh2YV+jKrok7grRhIaNCK3YSeyNAMeDWI8PPLCrZRIXX75/UXAwjr2xUF5IiX68uoAggr5ygWCnIZ64SPbipbhbwSe2tebo3wyK5Ub21V3frqQGqNsKJ2dKZ1e7pK+Oyqwm1USF2NEq8SVtjMeCL44/ILK4TPLypehbwSu/9ber5M+OIsr6Vq2YnaD479z5cJn6RfrlI+qa3X/qdLhHinij3uVVHn3D93ukSoGpUbFQZJWYpP+AmPenehCkUl+uOnfkKi34kq5JVo+Vyej1C+CgnM9jPpSPtSJfoI5e9CI24uL5m2gwayqeS/E32EDySrkJifwezAwSe6ZC1S52xxtfkj6egTMY+ACF/JEvqjUosyfSa7qKtMhJT+Nr/a7IH8oKJMhL4hxrxMuiZ71VIRkoE1u9rs/wPpoX2pCFH3zdR1zcoEEOUuF+Hc1szKJOsqUNkI5w5jWqb9W/lhU7kI57HTaZmerEfhUqtkhErbGyZOy7QDMLYvGSG1veiwVyaQQH7JCGfN1CsTRCMtHeG0mXplAokhlo1wOonhlmmXQETyy0aIuiOx8cQtE8ykdukIPafvlokYd5PQ3SAlyvTiHCQCVTpC6uwce4SNDkgcuHSESBUL3UWZQHxFGQldfyHK9HACckFifu5AXAex10CEpPHeJYSajiEDpR/yVuvTdXZ2fhbwSaG//aLDRKbdjhsn7DSApmPCw6W6sd5+HcsK+KQrsNC7OrkShDks8eoGEX7Mfp5LeEQM5Q0jVRgh94gYIgYVq6IIRTwKo61G9vO+RRFSe3KN0a6d/TcVRYjU+inOZV9McYT2Jc5l4rcwQsW8wUgD6kCESeS31AL94SAqLSaMiDXAGa4RoswRYKIfsBdAeFpzZoGwzGbX+Tgfg4TZVkVtjHRkjiaO8w+MJ2HdVbuhON99aY7OdAPxDk4GrZb32/BWE/gH5H033exYg+dpmoZtfPv0d123oJNrUWeMa13In07B+tmt89Jnu7CKj/fGrfVqbP648/Ezozmps9tpf1Yb9y9qANP4fqkX+Ks/wAgV3n2w9hvuJisb09pl7Uw/qxHRbaKNtU//8Knb8+Z0o3Zz+/uXeCxAtZ/2rhxASPUx/uYVDCG/9bZ+e24MUG1C39f+xHVB5qZH5u2uG0ToNR6KvFzCiA1tx/6C1ZF93FBVqFST6lP88i0EIXWQ8xQPENO+q+kemj+JcATh4hLC8rJOfYvbd/bT/hDG8KiPMMjYiTB17wbVTkYNLdD0JyF0xVuCfvHgzfO69pM+hjCBKsEHlnx7UEe1A6Th77WwJLuJCYWIg60vLaTd/AGQbkRh+NOR/KoArYUR+a8ebh9SEYorIutJDdEfiPSvTwiWD0Op1y+47b+wIn7wtIQi/cxDfje/kh6ckwamhiShqm7zf4dXUT93ekLU/f2vEFE3YmLNkLyf1QPBdhu5QHwTwgfi7TPZnA7UxHpN7hLEPKzz/+zXRoSbTk2oGHZH/N/8XZbQwgHjmlQi/SeC0DOlYb3Kbns90EhfhxWe92yp3XUfNi9k5/0YbklegdqfTOuHXTaskKTs6uHNairA5g/BM+vcV+DryYu692wkv8FFug49UzqV8v3eJUGstnooAg3KPb5W4W6vBneYMr9x7NtIA5ZETPo+FIk3ur6njn5rfhB90qVuGw34Q//b02Mu9t7YX/mQtCv5DS6OvC3liPbny0kbavVX7XPNHd+vVeeKiHdYCbsZb3/8+nZ5jMX6A2lAbkul/aFAHBwGtATlP7hWaxBDPA6YotDdf02l+d5hXw8D7hX6K0CvjftDkKk1VX/3rB72JlNZ499Tzn9OX/uXbr6sWUrEbBz7GSRZMe/TAPRLhVS2A5kpxJlcwIyeCMzYwr0UY51hR9ZsuWI/djBUtnBFhxkfuuJju1H36rEcJCO/4qEOF8bg40OYMf5Uwl3T7dpkEnpTRomx43rNQAAnuSzEx/hQcZqZOKRudupO6xY5rfDMP8uym5Pjv/c+CPMKHDRVn0LG2ubilEi3mHLT3/nz634bhYBqCPVbvdbbIR87a1a879xE6mPgeKlfxA2h6cgaTj7ZXu9527/UcY1gXbhK0Ia5JPUCPua9Jt7dNHbWDXbzwvJCjZl+tzPOZt5iVd0AwpgRMIzEvEUu+9MLI3TnnrKePxQqjlDMH+YyB1wUoTsHnMs8flGE7jx+LmsxCiMUazFyWU9TEKG3niaXNVEFERJ3NUQu69oKIpyua8tjbWIAYXi8FE7TtYlg60vDVRiht740h5QtBRHO1ghDrfOOUEGEs3XeqIuz7tUURKiwC9D9FhEqiHC+3wJoz0yEiiFc7JnJ3iMWQ7jY95S9RyyIcLF3DWb/YYSKIfTtP8x8nF8IoX8PKdTerlAVQri0DzjrpKyFEC7t5c464FYE4fJ+/KybaRGEKzkVMm6mRRCu5MWAyG0SoQIIV3Ob8DrN8vsKIFzLTwOQYyhCBRCu5RjKNh6VP6GIQXkCzPUVofwJ1fn5QYD52iKUO2FQvrZMBxi5Ewbm3MvSYeRNGJw3MctJqLwJQ3JfZpiCthuwAlJ6+W+4wvKXZpiDVrWfr7327VZmhGE5aLOsRDXgtXyq8J7lgr4H+byrfXrHTKr61v/0vuXVv/tnIyD0Cbrj51vcgzNK8li3kKUW+YNnuodnBVXbYyQ576nSh+kkO7PrHpy7dvfPzqvsuV3Jzz+8B2dY3v1zSO/BWbIVdBlpzwO+B2c63/1zuat2trr2JuytiL3qGq2MtVGG4bvkonbjV8bahFoZoSjCox5o2q3MRFh7dcjkU2RGhf3bKvRtqDOfKwxSdM6I7Xr5EanT+BD1fkxWjD3Z/DDZS40GjCMsP2IcYCxhLhu/JNS9iQGMJ+S1WN57kTp27IGECbLTNDplRaSOWKoeoyT5d55dldMvErYa/Q1SogxD37wqIyJhkX5wpmQ5lA77AKligKWy1kmSzyXMEoW7qGTdcAVNrhN9MHEeLKqXqhZVK6n1S57pq9vKcFlYSlHaTzw+T5HLrNEpi70hLIGXmClNtrZdZpfiZlRr+DT5p9PloyNG8c6fOmaqppQy416zXbTbUNnj71L9QdqcgrsmLRRRHRopWqhQ+qyJB4PiDA5hTuoY5wZ5IYvr4CTtxixpo8yXCkg6vLQimh049RKjzXJ7Hp3SvJsqYcNB6HlSUdo0e+neGCorXiJRhzXjBvMh2jw/q9KGPqohVNTGwXODSSSRgfbobSsXRs7XfxQR8o2RVI7dPBgl+SQJOSO+zu6QGOSeubDFZPikCfkFDvuZMXK+1slGBtQniFMnm1uZLEtXMLpezZG9gWDO1az/RbFgHSRh+uk4KEd2asEQIjHqMMAgOZ7ZA6g+V2CEvL/6rhWSkj2ViINZf/8EoECeAAm56gc9w5IwPNy06Gb7DUjrnAmWkGu3iQeYbdCl4x0zzDQ2Tjn8ixU4odC++l5fzTsfJcq4S2DWQ9jKmyoTQq4XN2On56bXjzogT5yrJ+BG7VpTPQ77lJyyInS1Rc7bI+p9h3u4lcfqcjHvVTQkvZ1Rsuj1ZsqUcPYd2BhgT/wxE3hzZf/t/wfdHG+w+Y5wkAAAAABJRU5ErkJggg=="
                          />
                        </defs>
                      </svg>
                    </div>
                    <div className="crypto-details">
                      <div className="crypto-name">USDT</div>
                      <div className="crypto-network">TRC-20</div>
                    </div>
                    <div className="crypto-arrow">›</div>
                  </div>
                  <div className="divider" />
                  {/* BTC Option */}
                  <div
                    className="crypto-option"
                    onMouseDown={handleMouseDown}
                    onMouseUp={(e) => {
					  handleMouseUp(e);
					  setSelectedCrypto("USDT_BEP20");
					  setShowCryptoModal(false);
					  navigate("/crypto-payment", {
						state: { amount: depositInput, selectedCrypto: "USDT_BEP20" },
					  });
					}}
                  >
                    <div className="crypto-ellipse">
                      <img
                        src={bnb}
                        alt="USDT"
                        style={{ width: 15, height: 15, borderRadius: "50%" }}
                      />
                    </div>
                    <div className="crypto-details">
                      <div className="crypto-name">USDT</div>
                      <div className="crypto-network">BEP-20</div>
                    </div>
                    <div className="crypto-arrow">›</div>
                  </div>
                  <div className="divider" />
                  <div
                    className="crypto-option"
                    onMouseDown={handleMouseDown}
                    onMouseUp={(e) => {
					  handleMouseUp(e);
					  setSelectedCrypto("TON");
					  setShowCryptoModal(false);
					  navigate("/crypto-payment", {
						state: { amount: depositInput, selectedCrypto: "TON" },
					  });
					}}
                  >
                    <div className="crypto-ellipse">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          width="15"
                          height="15"
                          fill="url(#pattern0_1_716)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_1_716"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlinkHref="#image0_1_716"
                              transform="scale(0.00444444)"
                            />
                          </pattern>
                          <image
                            id="image0_1_716"
                            width="225"
                            height="225"
                            preserveAspectRatio="none"
                            xlinkHref="data:image/png;base64,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"
                          />
                        </defs>
                      </svg>
                    </div>
                    <div className="crypto-details">
                      <div className="crypto-name">TON</div>
                      <div className="crypto-network">Toncoin</div>
                    </div>
                    <div className="crypto-arrow">›</div>
                  </div>

                  <div className="divider" />

                  <div
                    className="crypto-option"
                    onMouseDown={handleMouseDown}
                    onMouseUp={(e) => {
					  handleMouseUp(e);
					  setSelectedCrypto("TRX");
					  setShowCryptoModal(false);
					  navigate("/crypto-payment", {
						state: { amount: depositInput, selectedCrypto: "TRX" },
					  });
					}}
                  >
                    <div className="crypto-ellipse">
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          width="27"
                          height="27"
                          fill="url(#pattern0_1_717)"
                        />
                        <defs>
                          <pattern
                            id="pattern0_1_717"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlinkHref="#image0_1_717"
                              transform="scale(0.00444444)"
                            />
                          </pattern>
                          <image
                            id="image0_1_717"
                            width="225"
                            height="225"
                            preserveAspectRatio="none"
                            xlinkHref="data:image/png;base64,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"
                          />
                        </defs>
                      </svg>
                    </div>
                    <div className="crypto-details">
                      <div className="crypto-name">TRX</div>
                      <div className="crypto-network">Tron</div>
                    </div>
                    <div className="crypto-arrow">›</div>
                  </div>
                  <div className="divider" />
                  <div
                    className="crypto-option"
                    onMouseDown={handleMouseDown}
                    onMouseUp={(e) => {
					  handleMouseUp(e);
					  setSelectedCrypto("BTC");
					  setShowCryptoModal(false);
					  navigate("/crypto-payment", {
						state: { amount: depositInput, selectedCrypto: "BTC" },
					  });
					}}
                  >
                    <div className="crypto-ellipse">
                      <img
                        src={btc}
                        alt="btc"
                        style={{ width: 15, height: 15, borderRadius: "50%" }}
                      />
                    </div>
                    <div className="crypto-details">
                      <div className="crypto-name">BTC</div>
                      <div className="crypto-network">Bitcoin</div>
                    </div>
                    <div className="crypto-arrow">›</div>
                  </div>
                </div>
              </div>
            )}

            {showCryptoPaymentModal && (
              <div
                className="modal-overlay"
                onClick={(e) => {
                  if (e.target.classList.contains("modal-overlay")) {
                    setShowCryptoPaymentModal(false);
                  }
                }}
              >
                <div className="crypto-payment-modal">
                  <div className="crypto-payment-title">
                    Переведите точную сумму
                    <br />
                    на указанные реквизиты.
                  </div>

                  <div className="qr-outer-wrapper">
                    <div className="crypto-qr-box">
                      <div className="qr-white-padding">
                        <QRCodeCanvas
                          value={cryptoOptions[selectedCrypto].address}
                          size={100}
                          bgColor="#fff"
                          fgColor="#24c6dc"
                          level="H"
                          includeMargin={false}
                          className="qr-canvas"
                        />
                        <div className="qr-logo-circle">
                          <img src={logo} alt="logo" className="qr-logo-img" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="crypto-subtext">
                    Отправляйте только {cryptoOptions[selectedCrypto].label}
                    <br />
                    Сумма: {depositInput || "0"}₽ (~{cryptoAmount || "0.00"}{" "}
                    {cryptoOptions[selectedCrypto].short})
                  </div>

                  <div className="crypto-address-box">
                    <div className="crypto-address-title">
                      Адрес {cryptoOptions[selectedCrypto].label}
                    </div>
                    <div className="crypto-address-value">
                      {shortenAddress(cryptoOptions[selectedCrypto].address)}
                      <span
					  className="copy-icon"
					  onClick={async () => {
						const address = cryptoOptions[selectedCrypto].address;
						let copied = false;
						try {
						  if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
							await navigator.clipboard.writeText(address);
							copied = true;
						  }
						} catch {}
						if (!copied) {
						  try {
							const textarea = document.createElement("textarea");
							textarea.value = address;
							textarea.setAttribute("readonly", "");
							textarea.style.position = "fixed";
							textarea.style.opacity = "0";
							document.body.appendChild(textarea);
							textarea.select();
							document.execCommand("copy");
							document.body.removeChild(textarea);
							copied = true;
						  } catch {}
						}
						if (copied) {
						  setCopySuccess(true);
						  clearTimeout(copyTimeout.current);
						  copyTimeout.current = setTimeout(() => setCopySuccess(false), 2000);
						} else {
						  setToast("Не удалось скопировать адрес");
						}
					  }}
					  title="Скопировать адрес"
					>
					  <svg
						className="copy-icon-svg"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
					  >
						<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 18H8V7h11v16z" />
					  </svg>
					</span>
                      {copySuccess && (
                        <div className="copy-notification">Скопировано</div>
                      )}
                    </div>
                  </div>

                  <div className="crypto-actions">
                    <button
                      className="crypto-btn cancel"
                      onClick={() => setShowCryptoPaymentModal(false)}
                    >
                      Отмена
                    </button>
                    <button
                      className="crypto-btn confirm"
                      onClick={handleConfirm}
                      disabled={submitting}
                    >
                      {submitting ? "Отправка..." : "Подтвердить"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="invest-method-title">
              Выберите метод инвестирования
            </div>

            <button className="invest-method-btn" onClick={handleBankClick}>
              <div className="left">
                <svg
                  className="invest-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_card"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                  >
                    <rect width="16" height="16" fill="url(#pattern_card)" />
                  </mask>
                  <g mask="url(#mask0_card)">
                    <rect width="16" height="16" fill="#C0BBD9" />
                  </g>
                  <defs>
                    <pattern
                      id="pattern_card"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        xlinkHref="#image_card"
                        transform="scale(0.00195312)"
                      />
                    </pattern>
                    <image
                      id="image_card"
                      width="512"
                      height="512"
                      xlinkHref="data:image/png;base64,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"
                    />
                  </defs>
                </svg>
                <span>Банковская карта</span>
              </div>
              <svg
                className="arrow-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 6l6 6-6 6"
                  stroke="#E1E1E1"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button className="invest-method-btn" onClick={handleSbpClick}>
              <div
                className="left"
                style={{ display: "flex", alignItems: "center" }}
              >
                <span
                  style={{
                    width: 28,
                    height: 14,
                    display: "flex",
                    alignItems: "center",
                    marginRight: 8,
                  }}
                >
                  <svg
                    viewBox="0 0 178 86"
                    width="38"
                    height="18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_2_14384)">
                      <svg
                        viewBox="0 0 178 86"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_2_14384)">
                          <path
                            d="M90.5242 56.3338C90.2787 56.6342 89.9622 56.8686 89.6032 57.016C89.2211 57.1756 88.8106 57.2565 88.3964 57.254C87.9848 57.2617 87.5753 57.1917 87.1897 57.0477C86.8437 56.9211 86.5295 56.7208 86.2687 56.4607C85.9992 56.2076 85.7879 55.8991 85.6494 55.5565C85.505 55.1767 85.4349 54.7728 85.443 54.3667C85.4379 53.9814 85.5081 53.5988 85.6494 53.2403C85.7824 52.9024 85.9822 52.5949 86.2369 52.3361C86.4829 52.0726 86.7801 51.8621 87.1103 51.7174C87.4653 51.5619 87.8501 51.4861 88.2377 51.4953C88.6507 51.4892 89.0625 51.5426 89.4603 51.6539C89.8168 51.7625 90.143 51.9526 90.413 52.2091L89.9526 52.9865C89.7365 52.7894 89.4826 52.6383 89.2063 52.5423C88.9349 52.4527 88.6504 52.4098 88.3647 52.4154C88.1245 52.4153 87.8869 52.4639 87.666 52.5582C87.4314 52.6401 87.2193 52.776 87.0468 52.9548C86.8666 53.1293 86.7259 53.3402 86.6339 53.5735C86.531 53.8254 86.4771 54.0946 86.4751 54.3667C86.4773 54.649 86.5311 54.9286 86.6339 55.1916C86.7393 55.4254 86.8904 55.6358 87.0785 55.8103C87.2562 55.9789 87.4671 56.1085 87.6978 56.1911C87.9458 56.2872 88.2098 56.3356 88.4758 56.3338C88.7851 56.3428 89.0914 56.2718 89.365 56.1276C89.6237 56.0046 89.8556 55.8321 90.0478 55.6199L90.5242 56.3338Z"
                            fill="white"
                          />
                          <path
                            d="M91.7944 57.1271V51.6063H92.7789V55.7152L95.9705 51.6063H96.9391V57.1271H95.9705V53.0182L92.7789 57.1271H91.7944Z"
                            fill="white"
                          />
                          <path
                            d="M103.434 56.3338C103.192 56.6378 102.874 56.873 102.513 57.016C102.136 57.1752 101.731 57.2561 101.322 57.254C100.91 57.2617 100.501 57.1918 100.115 57.0477C99.7644 56.9214 99.4449 56.7212 99.1783 56.4608C98.9189 56.2025 98.7137 55.8951 98.5749 55.5565C98.4251 55.1778 98.3496 54.7739 98.3526 54.3667C98.3526 53.9804 98.4281 53.5977 98.5749 53.2403C98.7024 52.9034 98.8968 52.5958 99.1466 52.3361C99.3983 52.0722 99.7008 51.8618 100.036 51.7174C100.39 51.5604 100.775 51.4845 101.163 51.4953C101.571 51.4892 101.978 51.5426 102.37 51.6539C102.73 51.7548 103.058 51.9459 103.323 52.2092L102.878 52.9865C102.659 52.7857 102.399 52.6342 102.116 52.5423C101.85 52.4527 101.571 52.4097 101.29 52.4154C101.045 52.4166 100.802 52.4651 100.576 52.5582C100.347 52.6423 100.14 52.778 99.9723 52.9548C99.7875 53.1254 99.646 53.3375 99.5594 53.5735C99.4492 53.8232 99.3951 54.0939 99.4006 54.3667C99.3949 54.6498 99.449 54.9308 99.5594 55.1916C99.6649 55.4213 99.81 55.6308 99.9881 55.8103C100.172 55.9793 100.388 56.1088 100.623 56.1911C100.866 56.2871 101.125 56.3356 101.385 56.3338C101.7 56.3407 102.01 56.2699 102.291 56.1276C102.549 56.0046 102.781 55.8321 102.973 55.62L103.434 56.3338Z"
                            fill="white"
                          />
                          <path
                            d="M103.942 51.6063H108.975V52.5899H106.943V57.1271H105.958V52.5899H103.942V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M114.517 56.5242C114.239 56.7788 113.909 56.9685 113.548 57.0795C113.189 57.1927 112.814 57.2515 112.437 57.254C112.02 57.2618 111.605 57.1919 111.214 57.0478C110.868 56.9211 110.554 56.7208 110.293 56.4608C110.034 56.2025 109.829 55.8951 109.69 55.5565C109.546 55.1768 109.475 54.7729 109.484 54.3667C109.481 53.983 109.546 53.6019 109.674 53.2403C109.796 52.9042 109.985 52.5964 110.23 52.3361C110.479 52.0687 110.782 51.8578 111.119 51.7174C111.501 51.5588 111.912 51.4831 112.326 51.4953C112.667 51.4966 113.005 51.5556 113.326 51.6698C113.632 51.791 113.912 51.9686 114.152 52.1933C114.385 52.4178 114.568 52.6878 114.692 52.9865C114.835 53.3112 114.905 53.6631 114.898 54.0177C114.925 54.239 114.925 54.4627 114.898 54.684H110.659C110.662 54.9156 110.717 55.1436 110.819 55.3519C110.92 55.5602 111.066 55.7437 111.246 55.8897C111.621 56.1967 112.096 56.3548 112.58 56.3339C112.916 56.3356 113.249 56.2765 113.564 56.1593C113.822 56.0665 114.064 55.9326 114.279 55.7627L114.517 56.5242ZM112.278 52.4154C112.059 52.3971 111.839 52.4242 111.632 52.4952C111.424 52.5662 111.233 52.6795 111.071 52.8279C110.764 53.0947 110.57 53.4696 110.532 53.8749H113.882C113.872 53.4698 113.707 53.0838 113.421 52.7961C113.105 52.5241 112.695 52.3873 112.278 52.4154Z"
                            fill="white"
                          />
                          <path
                            d="M116.232 51.6063H117.121L119.249 54.335L121.265 51.6063H122.123V57.1271H121.154V53.0976L119.233 55.6676H119.201L117.216 53.0976V57.1271H116.232V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M123.949 51.9871C124.213 51.8313 124.496 51.7087 124.79 51.6222C125.117 51.539 125.453 51.4964 125.791 51.4953C126.083 51.469 126.376 51.508 126.651 51.6095C126.926 51.7111 127.174 51.8726 127.379 52.0822C127.726 52.5657 127.894 53.1544 127.855 53.748V57.1271H126.934V56.4132C126.756 56.6459 126.528 56.8357 126.267 56.9684C125.93 57.1468 125.553 57.2343 125.172 57.2223C124.714 57.2386 124.269 57.0732 123.933 56.7622C123.775 56.5952 123.653 56.3981 123.574 56.1827C123.495 55.9673 123.461 55.7381 123.473 55.5089C123.464 55.2512 123.519 54.9953 123.631 54.7633C123.734 54.5502 123.88 54.361 124.06 54.208C124.262 54.0597 124.487 53.9471 124.727 53.8749C124.995 53.7971 125.273 53.7597 125.553 53.7638C125.79 53.7424 126.029 53.7424 126.267 53.7638C126.509 53.8063 126.737 53.9041 126.934 54.0494C126.952 53.8171 126.952 53.5837 126.934 53.3514C126.917 53.1558 126.857 52.9663 126.759 52.7961C126.664 52.6751 126.538 52.5819 126.394 52.5264C126.19 52.4354 125.967 52.392 125.743 52.3995C125.426 52.3836 125.108 52.4267 124.806 52.5264L124.139 52.812L123.949 51.9871ZM125.537 56.3338C125.846 56.3489 126.152 56.2656 126.41 56.0959C126.615 55.9616 126.802 55.8016 126.966 55.62V54.9219C126.6 54.676 126.168 54.5486 125.727 54.5571C125.58 54.5414 125.43 54.5414 125.283 54.5571C125.148 54.5958 125.019 54.6546 124.902 54.7316C124.794 54.797 124.706 54.8901 124.648 55.0013C124.582 55.1288 124.55 55.2705 124.552 55.4137C124.547 55.5315 124.567 55.6491 124.61 55.7585C124.654 55.868 124.721 55.9668 124.806 56.0483C125.01 56.2186 125.272 56.3038 125.537 56.2863"
                            fill="white"
                          />
                          <path
                            d="M137.113 49.1949C136.965 49.3924 136.775 49.5549 136.557 49.6709C136.346 49.7585 136.128 49.8275 135.906 49.8771L135.16 50.0199C134.861 50.063 134.571 50.154 134.302 50.2896C134.053 50.3919 133.835 50.5557 133.667 50.7655C133.491 50.9558 133.352 51.1761 133.254 51.4159C133.142 51.6582 133.062 51.9143 133.016 52.1774C132.957 52.4329 132.92 52.693 132.905 52.9548C132.991 52.762 133.109 52.585 133.254 52.4313C133.411 52.2768 133.587 52.1435 133.778 52.0346C133.969 51.9128 134.178 51.8218 134.397 51.765C134.619 51.7012 134.849 51.6691 135.08 51.6698C135.446 51.6613 135.808 51.7316 136.144 51.876C136.452 51.9989 136.728 52.1886 136.954 52.4313C137.183 52.6766 137.357 52.9689 137.462 53.2879C137.593 53.6488 137.658 54.0304 137.653 54.4143C137.651 54.7902 137.575 55.1621 137.43 55.5089C137.303 55.8458 137.108 56.1534 136.859 56.4132C136.6 56.6724 136.292 56.8774 135.954 57.016C135.594 57.1768 135.204 57.2579 134.81 57.254C134.396 57.2611 133.984 57.18 133.603 57.016C133.25 56.8589 132.936 56.626 132.682 56.3338C132.413 56.0194 132.213 55.6519 132.095 55.2551C131.949 54.7881 131.879 54.3006 131.889 53.8114C131.893 53.3873 131.919 52.9637 131.968 52.5423C132.014 52.1045 132.11 51.6734 132.254 51.2573C132.406 50.8594 132.614 50.4854 132.873 50.1468C133.157 49.8033 133.523 49.5362 133.937 49.3694C134.213 49.2379 134.508 49.1471 134.81 49.0998L135.509 48.9728C135.705 48.9432 135.897 48.8899 136.081 48.8142C136.271 48.7251 136.435 48.5885 136.557 48.4176L137.113 49.1949ZM132.968 53.9542C132.966 54.2811 133.009 54.6067 133.095 54.9219C133.18 55.185 133.309 55.4317 133.476 55.6517C133.638 55.8445 133.838 56.0012 134.064 56.1117C134.302 56.2252 134.562 56.2848 134.826 56.2862C135.077 56.2897 135.326 56.2411 135.557 56.1435C135.771 56.043 135.965 55.9031 136.128 55.731C136.295 55.567 136.42 55.3658 136.493 55.144C136.591 54.9133 136.64 54.6648 136.636 54.4143C136.653 53.9285 136.489 53.4538 136.176 53.0817C136.015 52.8977 135.814 52.7533 135.588 52.6597C135.362 52.5662 135.118 52.526 134.874 52.5423C134.63 52.5404 134.388 52.5834 134.159 52.6692C133.954 52.746 133.761 52.853 133.588 52.9865C133.431 53.1107 133.296 53.261 133.191 53.4307C133.084 53.5893 133.008 53.7671 132.968 53.9542Z"
                            fill="white"
                          />
                          <path
                            d="M139.097 51.6063H140.082V53.2721H140.987C141.348 53.2594 141.709 53.3132 142.051 53.4307C142.301 53.5164 142.529 53.6574 142.718 53.8432C142.882 54.0183 143.002 54.2306 143.067 54.4619C143.144 54.6865 143.181 54.9226 143.178 55.1599C143.176 55.4085 143.133 55.6549 143.051 55.8897C142.978 56.1211 142.853 56.3327 142.686 56.5084C142.484 56.7082 142.24 56.86 141.971 56.9526C141.62 57.0772 141.248 57.1363 140.876 57.1271H139.097V51.6063ZM140.082 54.1922V56.207H140.796C141.159 56.2433 141.524 56.1537 141.828 55.9531C141.932 55.8598 142.013 55.7441 142.065 55.615C142.117 55.4858 142.139 55.3465 142.13 55.2075C142.141 55.066 142.119 54.924 142.067 54.792C142.015 54.6601 141.933 54.5418 141.828 54.446C141.528 54.249 141.17 54.1595 140.812 54.1922H140.082ZM144.226 51.6063H145.21V57.1271H144.226V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M151.673 56.3339C151.431 56.6378 151.114 56.873 150.752 57.016C150.37 57.1769 149.96 57.2579 149.545 57.254C149.139 57.2621 148.735 57.1921 148.354 57.0478C148.002 56.9251 147.682 56.7245 147.418 56.4608C147.158 56.2026 146.953 55.8951 146.814 55.5565C146.664 55.1779 146.589 54.7739 146.592 54.3667C146.594 53.9821 146.664 53.6009 146.798 53.2403C146.931 52.9025 147.131 52.5949 147.386 52.3361C147.638 52.0723 147.94 51.8618 148.275 51.7174C148.624 51.5617 149.004 51.4858 149.387 51.4953C149.8 51.4881 150.212 51.5416 150.609 51.6539C150.969 51.7548 151.297 51.946 151.562 52.2092L151.117 52.9865C150.898 52.7857 150.638 52.6342 150.355 52.5423C150.089 52.4527 149.81 52.4098 149.529 52.4154C149.284 52.4154 149.041 52.4639 148.815 52.5582C148.586 52.6423 148.379 52.778 148.212 52.9548C148.027 53.1254 147.885 53.3375 147.799 53.5735C147.689 53.8232 147.634 54.0939 147.64 54.3667C147.634 54.6498 147.688 54.9309 147.799 55.1916C147.904 55.4214 148.049 55.6308 148.227 55.8104C148.411 55.9793 148.627 56.1089 148.863 56.1911C149.105 56.2871 149.364 56.3356 149.625 56.3339C149.939 56.3407 150.25 56.2699 150.53 56.1276C150.788 56.0046 151.02 55.8322 151.213 55.62L151.673 56.3339Z"
                            fill="white"
                          />
                          <path
                            d="M152.181 51.6063H157.199V52.5899H155.182V57.1271H154.198V52.5899H152.181V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M158.279 51.6064H159.263V52.2568C159.474 52.0155 159.741 51.8301 160.041 51.7174C160.386 51.565 160.76 51.4892 161.137 51.4953C161.502 51.4868 161.865 51.5571 162.201 51.7015C162.499 51.8401 162.769 52.0339 162.995 52.2726C163.225 52.5299 163.398 52.8326 163.503 53.161C163.634 53.5219 163.699 53.9035 163.693 54.2874C163.691 54.6875 163.621 55.0843 163.487 55.4614C163.354 55.8088 163.155 56.1268 162.9 56.3974C162.643 56.6664 162.335 56.882 161.994 57.0319C161.62 57.1796 161.222 57.255 160.819 57.254C160.531 57.2555 160.243 57.2236 159.962 57.1588C159.714 57.1057 159.477 57.009 159.263 56.8733V59.5861H158.279V51.6064ZM160.851 52.4154C160.53 52.408 160.213 52.4845 159.93 52.6375C159.669 52.7639 159.441 52.9484 159.263 53.1769V55.9056C159.482 56.055 159.723 56.1675 159.978 56.2387C160.221 56.3024 160.472 56.3344 160.724 56.3339C161.002 56.3413 161.279 56.2871 161.534 56.1753C161.757 56.0807 161.957 55.9401 162.121 55.7628C162.297 55.5842 162.427 55.3668 162.503 55.1282C162.602 54.8702 162.65 54.5955 162.645 54.3191C162.642 54.0615 162.605 53.8055 162.534 53.5576C162.459 53.3319 162.335 53.1259 162.169 52.9548C162.023 52.775 161.831 52.638 161.613 52.5582C161.372 52.4594 161.112 52.4108 160.851 52.4154Z"
                            fill="white"
                          />
                          <path
                            d="M165.091 51.6063H166.091V53.2721H166.996C167.358 53.2594 167.718 53.3132 168.06 53.4307C168.311 53.5164 168.539 53.6574 168.727 53.8432C168.892 54.0183 169.012 54.2306 169.076 54.4619C169.153 54.6865 169.191 54.9226 169.188 55.1599C169.185 55.4085 169.142 55.6549 169.06 55.8897C168.989 56.1253 168.858 56.3384 168.679 56.5084C168.486 56.7112 168.246 56.8637 167.981 56.9526C167.629 57.0745 167.258 57.1336 166.885 57.1271H165.107L165.091 51.6063ZM166.075 54.1922V56.207H166.79C167.153 56.2433 167.517 56.1537 167.822 55.9531C167.925 55.8598 168.006 55.7441 168.059 55.615C168.111 55.4858 168.133 55.3465 168.124 55.2075C168.134 55.066 168.113 54.924 168.061 54.792C168.008 54.6601 167.927 54.5418 167.822 54.446C167.522 54.249 167.163 54.1595 166.806 54.1922H166.075ZM170.22 51.6063H171.204V57.1271H170.22V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M175.904 54.2715L178 57.1271H176.793L175.174 54.8902L173.538 57.1271H172.395L174.475 54.3191L172.522 51.6063H173.713L175.206 53.6845L176.73 51.6063H177.873L175.904 54.2715Z"
                            fill="white"
                          />
                          <path
                            d="M89.7941 63.9328H86.7931V68.5334H85.8086V63.0127H90.7786V68.5334H89.7941V63.9328Z"
                            fill="white"
                          />
                          <path
                            d="M96.336 64.0122H94.3988V64.9323C94.363 65.5754 94.2619 66.2133 94.0971 66.836C94.011 67.2332 93.8493 67.6102 93.6207 67.9465C93.4647 68.1892 93.2373 68.3776 92.9697 68.4859C92.7136 68.5703 92.4455 68.6131 92.1758 68.6128V67.6609C92.3014 67.6879 92.4313 67.6879 92.5569 67.6609C92.7235 67.561 92.8605 67.4187 92.9538 67.2485C93.1144 66.9716 93.2322 66.6721 93.3032 66.3601C93.4382 65.8416 93.5128 65.3092 93.5255 64.7736L93.6207 63.0603H97.4634V68.581H96.4789L96.336 64.0122Z"
                            fill="white"
                          />
                          <path
                            d="M99.1146 63.4093C99.3737 63.2435 99.6579 63.1203 99.9562 63.0445C100.281 62.9482 100.618 62.9001 100.957 62.9017C101.248 62.8742 101.543 62.9127 101.817 63.0143C102.092 63.1159 102.341 63.2781 102.544 63.4887C102.889 63.9732 103.057 64.5611 103.021 65.1544V68.5335H102.1V67.8354C101.918 68.064 101.691 68.253 101.433 68.3907C101.095 68.565 100.717 68.6471 100.337 68.6287C99.8871 68.6468 99.4479 68.4872 99.1146 68.1845C98.9463 68.0212 98.8163 67.8227 98.7339 67.6033C98.6515 67.3838 98.6189 67.1489 98.6382 66.9153C98.6297 66.6576 98.6842 66.4017 98.797 66.1697C98.8998 65.9569 99.0523 65.7719 99.2416 65.6303C99.4307 65.4681 99.6528 65.349 99.8926 65.2813C100.166 65.2033 100.45 65.1659 100.734 65.1703C100.969 65.1758 101.203 65.2023 101.433 65.2496C101.671 65.2936 101.898 65.3853 102.1 65.5193C102.117 65.2869 102.117 65.0536 102.1 64.8212C102.085 64.6273 102.031 64.4383 101.941 64.266C101.846 64.1188 101.715 63.9985 101.56 63.917C101.351 63.8205 101.122 63.777 100.893 63.7901C100.608 63.7803 100.324 63.8178 100.051 63.9011C99.8173 63.9799 99.5891 64.0753 99.3686 64.1867L99.1146 63.4093ZM100.702 67.7403C101.014 67.7498 101.322 67.673 101.592 67.5182C101.793 67.3791 101.974 67.2137 102.132 67.0264V66.3283C101.766 66.0824 101.334 65.955 100.893 65.9635C100.751 65.9404 100.606 65.9404 100.464 65.9635C100.33 65.997 100.202 66.0505 100.083 66.1221C99.9737 66.1968 99.8816 66.2942 99.8132 66.4077C99.7481 66.5296 99.7153 66.6661 99.718 66.8043C99.7114 66.9222 99.7308 67.0401 99.7747 67.1497C99.8185 67.2593 99.8859 67.358 99.972 67.4388C100.176 67.6091 100.437 67.6944 100.702 67.6768"
                            fill="white"
                          />
                          <path
                            d="M104.021 63.0127H109.055V63.9963H107.022V68.5334H106.053V63.9963H104.021V63.0127Z"
                            fill="white"
                          />
                          <path
                            d="M114.596 67.9465C114.321 68.1926 113.996 68.3765 113.644 68.4859C113.285 68.6045 112.91 68.6635 112.532 68.6604C112.115 68.6698 111.7 68.5998 111.31 68.4542C110.958 68.3372 110.638 68.1419 110.373 67.8831C110.109 67.6253 109.908 67.3105 109.785 66.963C109.643 66.5882 109.573 66.1898 109.579 65.789C109.568 65.4061 109.628 65.0245 109.753 64.6626C109.871 64.32 110.061 64.0064 110.309 63.7425C110.562 63.4803 110.864 63.2701 111.198 63.1238C111.587 62.9701 112.003 62.8946 112.421 62.9017C112.764 62.9004 113.103 62.965 113.421 63.0921C113.726 63.1978 114.003 63.3713 114.231 63.5997C114.461 63.827 114.644 64.0963 114.771 64.3929C114.913 64.7181 114.983 65.0697 114.978 65.4241C115.004 65.6454 115.004 65.8691 114.978 66.0904H110.674C110.683 66.3234 110.74 66.5522 110.841 66.7623C110.942 66.9725 111.085 67.1596 111.262 67.312C111.642 67.6082 112.114 67.76 112.596 67.7403C112.931 67.7482 113.265 67.6945 113.58 67.5817C113.843 67.491 114.085 67.351 114.295 67.1692L114.596 67.9465ZM112.373 63.8218C111.929 63.8015 111.492 63.9487 111.151 64.2343C110.853 64.5152 110.662 64.891 110.611 65.2972H113.961C113.963 65.0954 113.924 64.8953 113.844 64.7096C113.765 64.5239 113.648 64.3567 113.501 64.2184C113.191 63.9446 112.787 63.8023 112.373 63.8218Z"
                            fill="white"
                          />
                          <path
                            d="M115.454 63.0286H116.692L118.582 65.6779L116.565 68.5335H115.358L117.486 65.6779L115.454 63.0286ZM118.836 63.0286H119.82V68.5335H118.836V63.0286ZM121.17 65.6779L123.329 68.5335H122.107L120.058 65.6779L121.964 63.0286H123.218L121.17 65.6779Z"
                            fill="white"
                          />
                          <path
                            d="M128.76 67.9464C128.482 68.1962 128.151 68.3805 127.792 68.4858C127.434 68.6068 127.058 68.6658 126.68 68.6603C126.268 68.6704 125.859 68.6004 125.474 68.4541C125.122 68.3371 124.802 68.1418 124.537 67.883C124.273 67.6218 124.068 67.3084 123.933 66.9629C123.797 66.5865 123.727 66.1892 123.727 65.7889C123.722 65.405 123.786 65.0234 123.917 64.6625C124.035 64.3199 124.225 64.0063 124.473 63.7424C124.726 63.4802 125.028 63.27 125.362 63.1237C125.746 62.972 126.156 62.8966 126.569 62.9016C126.912 62.8974 127.252 62.9622 127.569 63.092C127.877 63.2012 128.159 63.3742 128.395 63.5996C128.625 63.8269 128.808 64.0962 128.935 64.3928C129.077 64.718 129.147 65.0696 129.141 65.424C129.168 65.6453 129.168 65.869 129.141 66.0903H124.807C124.808 66.3247 124.862 66.5557 124.963 66.7669C125.065 66.9781 125.212 67.1643 125.394 67.3119C125.774 67.6081 126.247 67.7599 126.728 67.7402C127.063 67.7471 127.397 67.6933 127.712 67.5816C127.971 67.4837 128.213 67.3443 128.427 67.1691L128.76 67.9464ZM126.522 63.8217C126.081 63.8007 125.65 63.9483 125.315 64.2342C125.011 64.5108 124.819 64.8888 124.775 65.2971H128.125C128.115 64.892 127.951 64.506 127.665 64.2183C127.351 63.9405 126.94 63.798 126.522 63.8217Z"
                            fill="white"
                          />
                          <path
                            d="M130.475 68.5493V63.0285H131.46V67.1374L134.635 63.0285H135.62V68.5493H134.635V64.4405L131.46 68.5493H130.475ZM132.174 60.2047C132.174 60.8551 132.539 61.1724 133.127 61.1724C133.714 61.1724 133.968 60.8551 134.016 60.2047H134.937C134.946 60.4387 134.902 60.6716 134.81 60.8869C134.727 61.09 134.603 61.2736 134.445 61.4263C134.28 61.5837 134.086 61.7076 133.873 61.7911C133.633 61.8758 133.381 61.9187 133.127 61.9181C132.852 61.9198 132.578 61.877 132.317 61.7911C132.102 61.7121 131.907 61.5876 131.745 61.4263C131.588 61.2736 131.463 61.09 131.38 60.8869C131.301 60.6684 131.263 60.437 131.269 60.2047H132.174Z"
                            fill="white"
                          />
                          <path
                            d="M21.6426 42.9921L10.4164 49.4647L0 67.5023L42.4913 42.9921H21.6426Z"
                            fill="#874691"
                          />
                          <path
                            d="M53.7174 24.5103L42.4911 30.9829L32.0747 49.0205L74.5502 24.5103H53.7174Z"
                            fill="#DA1844"
                          />
                          <path
                            d="M42.4911 18.0376L32.0747 0V36.9795V49.0205V86L42.4911 67.9624V18.0376Z"
                            fill="#F9B229"
                          />
                          <path
                            d="M32.0747 0L42.4911 18.0376L53.7174 24.5102H74.5502L32.0747 0Z"
                            fill="#F07F1A"
                          />
                          <path
                            d="M32.0747 36.9795V86L42.4911 67.9623V55.0013L32.0747 36.9795Z"
                            fill="#72B22C"
                          />
                          <path
                            d="M53.7174 61.4897L42.4911 67.9624L32.0747 86L74.5502 61.4897H53.7174Z"
                            fill="#00743E"
                          />
                          <path
                            d="M0 18.4818V67.5023L10.4164 49.4647V36.5194L0 18.4818Z"
                            fill="#5F5A94"
                          />
                          <path
                            d="M32.0749 36.9795V36.9954L0 18.4818L10.4164 36.5194L53.7176 61.4897H74.5504L32.0749 36.9795Z"
                            fill="#0D90CD"
                          />
                          <path
                            d="M159.136 21.1311V43.1982H151.387V27.6989H143.908V43.1982H136.16V21.1311H159.136Z"
                            fill="white"
                          />
                          <path
                            d="M132.333 32.8707C132.444 39.2164 127.268 43.8329 119.932 43.8329C112.977 43.8329 107.118 39.6289 107.118 29.3964C107.118 20.7028 112.675 13.5322 120.884 13.4053H132.333L128.697 19.9414H121.71C119.98 19.8853 118.291 20.4697 116.966 21.5824C115.641 22.6951 114.775 24.2576 114.533 25.9697C116.739 24.0801 119.567 23.074 122.472 23.1459C125.062 23.1853 127.538 24.2188 129.385 26.0323C131.233 27.8458 132.311 30.3002 132.397 32.8865M124.648 33.3942C124.658 32.7842 124.547 32.1781 124.32 31.6116C124.093 31.0452 123.755 30.5296 123.327 30.0952C122.898 29.6608 122.386 29.3164 121.822 29.082C121.259 28.8475 120.654 28.7279 120.043 28.7301C119.413 28.7149 118.787 28.8276 118.202 29.0614C117.617 29.2952 117.086 29.6452 116.641 30.0902C116.195 30.5352 115.845 31.066 115.611 31.6503C115.377 32.2346 115.264 32.8602 115.279 33.4894C115.303 34.6813 115.785 35.8185 116.624 36.6658C117.463 37.5132 118.596 38.006 119.789 38.0424C120.406 38.0593 121.02 37.953 121.595 37.7298C122.17 37.5066 122.695 37.1709 123.139 36.7424C123.582 36.3139 123.936 35.8013 124.179 35.2345C124.421 34.6678 124.548 34.0583 124.552 33.4418"
                            fill="white"
                          />
                          <path
                            d="M101.419 35.6628C99.5871 36.7752 97.4817 37.3574 95.3377 37.3444C93.9756 37.2993 92.6838 36.7289 91.7335 35.7528C90.7832 34.7768 90.2481 33.4709 90.2407 32.1092C90.2483 30.7449 90.7855 29.4368 91.7392 28.4603C92.6929 27.4838 93.9887 26.9151 95.3536 26.874C97.494 26.8504 99.5972 27.4335 101.419 28.5556L104.309 23.3522C101.871 21.4657 98.8658 20.4593 95.7823 20.4966C88.2082 20.4966 83 26.6519 83 32.1092C83 38.4549 88.7798 43.8012 95.703 43.8329C98.8158 43.8863 101.853 42.873 104.309 40.9615L101.419 35.6628Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2_14384">
                            <rect width="178" height="86" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </g>
                    <defs>
                      <clipPath id="clip0_2_14384">
                        <rect width="178" height="86" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span>СБП</span>
              </div>
              <svg
                className="arrow-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 6l6 6-6 6"
                  stroke="#E1E1E1"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button className="invest-method-btn" onClick={handleSbp2Click}>
              <div
                className="left"
                style={{ display: "flex", alignItems: "center" }}
              >
                <span
                  style={{
                    width: 28,
                    height: 14,
                    display: "flex",
                    alignItems: "center",
                    marginRight: 8,
                  }}
                >
                  <svg
                    viewBox="0 0 178 86"
                    width="38"
                    height="18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_2_14384)">
                      <svg
                        viewBox="0 0 178 86"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_2_14384)">
                          <path
                            d="M90.5242 56.3338C90.2787 56.6342 89.9622 56.8686 89.6032 57.016C89.2211 57.1756 88.8106 57.2565 88.3964 57.254C87.9848 57.2617 87.5753 57.1917 87.1897 57.0477C86.8437 56.9211 86.5295 56.7208 86.2687 56.4607C85.9992 56.2076 85.7879 55.8991 85.6494 55.5565C85.505 55.1767 85.4349 54.7728 85.443 54.3667C85.4379 53.9814 85.5081 53.5988 85.6494 53.2403C85.7824 52.9024 85.9822 52.5949 86.2369 52.3361C86.4829 52.0726 86.7801 51.8621 87.1103 51.7174C87.4653 51.5619 87.8501 51.4861 88.2377 51.4953C88.6507 51.4892 89.0625 51.5426 89.4603 51.6539C89.8168 51.7625 90.143 51.9526 90.413 52.2091L89.9526 52.9865C89.7365 52.7894 89.4826 52.6383 89.2063 52.5423C88.9349 52.4527 88.6504 52.4098 88.3647 52.4154C88.1245 52.4153 87.8869 52.4639 87.666 52.5582C87.4314 52.6401 87.2193 52.776 87.0468 52.9548C86.8666 53.1293 86.7259 53.3402 86.6339 53.5735C86.531 53.8254 86.4771 54.0946 86.4751 54.3667C86.4773 54.649 86.5311 54.9286 86.6339 55.1916C86.7393 55.4254 86.8904 55.6358 87.0785 55.8103C87.2562 55.9789 87.4671 56.1085 87.6978 56.1911C87.9458 56.2872 88.2098 56.3356 88.4758 56.3338C88.7851 56.3428 89.0914 56.2718 89.365 56.1276C89.6237 56.0046 89.8556 55.8321 90.0478 55.6199L90.5242 56.3338Z"
                            fill="white"
                          />
                          <path
                            d="M91.7944 57.1271V51.6063H92.7789V55.7152L95.9705 51.6063H96.9391V57.1271H95.9705V53.0182L92.7789 57.1271H91.7944Z"
                            fill="white"
                          />
                          <path
                            d="M103.434 56.3338C103.192 56.6378 102.874 56.873 102.513 57.016C102.136 57.1752 101.731 57.2561 101.322 57.254C100.91 57.2617 100.501 57.1918 100.115 57.0477C99.7644 56.9214 99.4449 56.7212 99.1783 56.4608C98.9189 56.2025 98.7137 55.8951 98.5749 55.5565C98.4251 55.1778 98.3496 54.7739 98.3526 54.3667C98.3526 53.9804 98.4281 53.5977 98.5749 53.2403C98.7024 52.9034 98.8968 52.5958 99.1466 52.3361C99.3983 52.0722 99.7008 51.8618 100.036 51.7174C100.39 51.5604 100.775 51.4845 101.163 51.4953C101.571 51.4892 101.978 51.5426 102.37 51.6539C102.73 51.7548 103.058 51.9459 103.323 52.2092L102.878 52.9865C102.659 52.7857 102.399 52.6342 102.116 52.5423C101.85 52.4527 101.571 52.4097 101.29 52.4154C101.045 52.4166 100.802 52.4651 100.576 52.5582C100.347 52.6423 100.14 52.778 99.9723 52.9548C99.7875 53.1254 99.646 53.3375 99.5594 53.5735C99.4492 53.8232 99.3951 54.0939 99.4006 54.3667C99.3949 54.6498 99.449 54.9308 99.5594 55.1916C99.6649 55.4213 99.81 55.6308 99.9881 55.8103C100.172 55.9793 100.388 56.1088 100.623 56.1911C100.866 56.2871 101.125 56.3356 101.385 56.3338C101.7 56.3407 102.01 56.2699 102.291 56.1276C102.549 56.0046 102.781 55.8321 102.973 55.62L103.434 56.3338Z"
                            fill="white"
                          />
                          <path
                            d="M103.942 51.6063H108.975V52.5899H106.943V57.1271H105.958V52.5899H103.942V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M114.517 56.5242C114.239 56.7788 113.909 56.9685 113.548 57.0795C113.189 57.1927 112.814 57.2515 112.437 57.254C112.02 57.2618 111.605 57.1919 111.214 57.0478C110.868 56.9211 110.554 56.7208 110.293 56.4608C110.034 56.2025 109.829 55.8951 109.69 55.5565C109.546 55.1768 109.475 54.7729 109.484 54.3667C109.481 53.983 109.546 53.6019 109.674 53.2403C109.796 52.9042 109.985 52.5964 110.23 52.3361C110.479 52.0687 110.782 51.8578 111.119 51.7174C111.501 51.5588 111.912 51.4831 112.326 51.4953C112.667 51.4966 113.005 51.5556 113.326 51.6698C113.632 51.791 113.912 51.9686 114.152 52.1933C114.385 52.4178 114.568 52.6878 114.692 52.9865C114.835 53.3112 114.905 53.6631 114.898 54.0177C114.925 54.239 114.925 54.4627 114.898 54.684H110.659C110.662 54.9156 110.717 55.1436 110.819 55.3519C110.92 55.5602 111.066 55.7437 111.246 55.8897C111.621 56.1967 112.096 56.3548 112.58 56.3339C112.916 56.3356 113.249 56.2765 113.564 56.1593C113.822 56.0665 114.064 55.9326 114.279 55.7627L114.517 56.5242ZM112.278 52.4154C112.059 52.3971 111.839 52.4242 111.632 52.4952C111.424 52.5662 111.233 52.6795 111.071 52.8279C110.764 53.0947 110.57 53.4696 110.532 53.8749H113.882C113.872 53.4698 113.707 53.0838 113.421 52.7961C113.105 52.5241 112.695 52.3873 112.278 52.4154Z"
                            fill="white"
                          />
                          <path
                            d="M116.232 51.6063H117.121L119.249 54.335L121.265 51.6063H122.123V57.1271H121.154V53.0976L119.233 55.6676H119.201L117.216 53.0976V57.1271H116.232V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M123.949 51.9871C124.213 51.8313 124.496 51.7087 124.79 51.6222C125.117 51.539 125.453 51.4964 125.791 51.4953C126.083 51.469 126.376 51.508 126.651 51.6095C126.926 51.7111 127.174 51.8726 127.379 52.0822C127.726 52.5657 127.894 53.1544 127.855 53.748V57.1271H126.934V56.4132C126.756 56.6459 126.528 56.8357 126.267 56.9684C125.93 57.1468 125.553 57.2343 125.172 57.2223C124.714 57.2386 124.269 57.0732 123.933 56.7622C123.775 56.5952 123.653 56.3981 123.574 56.1827C123.495 55.9673 123.461 55.7381 123.473 55.5089C123.464 55.2512 123.519 54.9953 123.631 54.7633C123.734 54.5502 123.88 54.361 124.06 54.208C124.262 54.0597 124.487 53.9471 124.727 53.8749C124.995 53.7971 125.273 53.7597 125.553 53.7638C125.79 53.7424 126.029 53.7424 126.267 53.7638C126.509 53.8063 126.737 53.9041 126.934 54.0494C126.952 53.8171 126.952 53.5837 126.934 53.3514C126.917 53.1558 126.857 52.9663 126.759 52.7961C126.664 52.6751 126.538 52.5819 126.394 52.5264C126.19 52.4354 125.967 52.392 125.743 52.3995C125.426 52.3836 125.108 52.4267 124.806 52.5264L124.139 52.812L123.949 51.9871ZM125.537 56.3338C125.846 56.3489 126.152 56.2656 126.41 56.0959C126.615 55.9616 126.802 55.8016 126.966 55.62V54.9219C126.6 54.676 126.168 54.5486 125.727 54.5571C125.58 54.5414 125.43 54.5414 125.283 54.5571C125.148 54.5958 125.019 54.6546 124.902 54.7316C124.794 54.797 124.706 54.8901 124.648 55.0013C124.582 55.1288 124.55 55.2705 124.552 55.4137C124.547 55.5315 124.567 55.6491 124.61 55.7585C124.654 55.868 124.721 55.9668 124.806 56.0483C125.01 56.2186 125.272 56.3038 125.537 56.2863"
                            fill="white"
                          />
                          <path
                            d="M137.113 49.1949C136.965 49.3924 136.775 49.5549 136.557 49.6709C136.346 49.7585 136.128 49.8275 135.906 49.8771L135.16 50.0199C134.861 50.063 134.571 50.154 134.302 50.2896C134.053 50.3919 133.835 50.5557 133.667 50.7655C133.491 50.9558 133.352 51.1761 133.254 51.4159C133.142 51.6582 133.062 51.9143 133.016 52.1774C132.957 52.4329 132.92 52.693 132.905 52.9548C132.991 52.762 133.109 52.585 133.254 52.4313C133.411 52.2768 133.587 52.1435 133.778 52.0346C133.969 51.9128 134.178 51.8218 134.397 51.765C134.619 51.7012 134.849 51.6691 135.08 51.6698C135.446 51.6613 135.808 51.7316 136.144 51.876C136.452 51.9989 136.728 52.1886 136.954 52.4313C137.183 52.6766 137.357 52.9689 137.462 53.2879C137.593 53.6488 137.658 54.0304 137.653 54.4143C137.651 54.7902 137.575 55.1621 137.43 55.5089C137.303 55.8458 137.108 56.1534 136.859 56.4132C136.6 56.6724 136.292 56.8774 135.954 57.016C135.594 57.1768 135.204 57.2579 134.81 57.254C134.396 57.2611 133.984 57.18 133.603 57.016C133.25 56.8589 132.936 56.626 132.682 56.3338C132.413 56.0194 132.213 55.6519 132.095 55.2551C131.949 54.7881 131.879 54.3006 131.889 53.8114C131.893 53.3873 131.919 52.9637 131.968 52.5423C132.014 52.1045 132.11 51.6734 132.254 51.2573C132.406 50.8594 132.614 50.4854 132.873 50.1468C133.157 49.8033 133.523 49.5362 133.937 49.3694C134.213 49.2379 134.508 49.1471 134.81 49.0998L135.509 48.9728C135.705 48.9432 135.897 48.8899 136.081 48.8142C136.271 48.7251 136.435 48.5885 136.557 48.4176L137.113 49.1949ZM132.968 53.9542C132.966 54.2811 133.009 54.6067 133.095 54.9219C133.18 55.185 133.309 55.4317 133.476 55.6517C133.638 55.8445 133.838 56.0012 134.064 56.1117C134.302 56.2252 134.562 56.2848 134.826 56.2862C135.077 56.2897 135.326 56.2411 135.557 56.1435C135.771 56.043 135.965 55.9031 136.128 55.731C136.295 55.567 136.42 55.3658 136.493 55.144C136.591 54.9133 136.64 54.6648 136.636 54.4143C136.653 53.9285 136.489 53.4538 136.176 53.0817C136.015 52.8977 135.814 52.7533 135.588 52.6597C135.362 52.5662 135.118 52.526 134.874 52.5423C134.63 52.5404 134.388 52.5834 134.159 52.6692C133.954 52.746 133.761 52.853 133.588 52.9865C133.431 53.1107 133.296 53.261 133.191 53.4307C133.084 53.5893 133.008 53.7671 132.968 53.9542Z"
                            fill="white"
                          />
                          <path
                            d="M139.097 51.6063H140.082V53.2721H140.987C141.348 53.2594 141.709 53.3132 142.051 53.4307C142.301 53.5164 142.529 53.6574 142.718 53.8432C142.882 54.0183 143.002 54.2306 143.067 54.4619C143.144 54.6865 143.181 54.9226 143.178 55.1599C143.176 55.4085 143.133 55.6549 143.051 55.8897C142.978 56.1211 142.853 56.3327 142.686 56.5084C142.484 56.7082 142.24 56.86 141.971 56.9526C141.62 57.0772 141.248 57.1363 140.876 57.1271H139.097V51.6063ZM140.082 54.1922V56.207H140.796C141.159 56.2433 141.524 56.1537 141.828 55.9531C141.932 55.8598 142.013 55.7441 142.065 55.615C142.117 55.4858 142.139 55.3465 142.13 55.2075C142.141 55.066 142.119 54.924 142.067 54.792C142.015 54.6601 141.933 54.5418 141.828 54.446C141.528 54.249 141.17 54.1595 140.812 54.1922H140.082ZM144.226 51.6063H145.21V57.1271H144.226V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M151.673 56.3339C151.431 56.6378 151.114 56.873 150.752 57.016C150.37 57.1769 149.96 57.2579 149.545 57.254C149.139 57.2621 148.735 57.1921 148.354 57.0478C148.002 56.9251 147.682 56.7245 147.418 56.4608C147.158 56.2026 146.953 55.8951 146.814 55.5565C146.664 55.1779 146.589 54.7739 146.592 54.3667C146.594 53.9821 146.664 53.6009 146.798 53.2403C146.931 52.9025 147.131 52.5949 147.386 52.3361C147.638 52.0723 147.94 51.8618 148.275 51.7174C148.624 51.5617 149.004 51.4858 149.387 51.4953C149.8 51.4881 150.212 51.5416 150.609 51.6539C150.969 51.7548 151.297 51.946 151.562 52.2092L151.117 52.9865C150.898 52.7857 150.638 52.6342 150.355 52.5423C150.089 52.4527 149.81 52.4098 149.529 52.4154C149.284 52.4154 149.041 52.4639 148.815 52.5582C148.586 52.6423 148.379 52.778 148.212 52.9548C148.027 53.1254 147.885 53.3375 147.799 53.5735C147.689 53.8232 147.634 54.0939 147.64 54.3667C147.634 54.6498 147.688 54.9309 147.799 55.1916C147.904 55.4214 148.049 55.6308 148.227 55.8104C148.411 55.9793 148.627 56.1089 148.863 56.1911C149.105 56.2871 149.364 56.3356 149.625 56.3339C149.939 56.3407 150.25 56.2699 150.53 56.1276C150.788 56.0046 151.02 55.8322 151.213 55.62L151.673 56.3339Z"
                            fill="white"
                          />
                          <path
                            d="M152.181 51.6063H157.199V52.5899H155.182V57.1271H154.198V52.5899H152.181V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M158.279 51.6064H159.263V52.2568C159.474 52.0155 159.741 51.8301 160.041 51.7174C160.386 51.565 160.76 51.4892 161.137 51.4953C161.502 51.4868 161.865 51.5571 162.201 51.7015C162.499 51.8401 162.769 52.0339 162.995 52.2726C163.225 52.5299 163.398 52.8326 163.503 53.161C163.634 53.5219 163.699 53.9035 163.693 54.2874C163.691 54.6875 163.621 55.0843 163.487 55.4614C163.354 55.8088 163.155 56.1268 162.9 56.3974C162.643 56.6664 162.335 56.882 161.994 57.0319C161.62 57.1796 161.222 57.255 160.819 57.254C160.531 57.2555 160.243 57.2236 159.962 57.1588C159.714 57.1057 159.477 57.009 159.263 56.8733V59.5861H158.279V51.6064ZM160.851 52.4154C160.53 52.408 160.213 52.4845 159.93 52.6375C159.669 52.7639 159.441 52.9484 159.263 53.1769V55.9056C159.482 56.055 159.723 56.1675 159.978 56.2387C160.221 56.3024 160.472 56.3344 160.724 56.3339C161.002 56.3413 161.279 56.2871 161.534 56.1753C161.757 56.0807 161.957 55.9401 162.121 55.7628C162.297 55.5842 162.427 55.3668 162.503 55.1282C162.602 54.8702 162.65 54.5955 162.645 54.3191C162.642 54.0615 162.605 53.8055 162.534 53.5576C162.459 53.3319 162.335 53.1259 162.169 52.9548C162.023 52.775 161.831 52.638 161.613 52.5582C161.372 52.4594 161.112 52.4108 160.851 52.4154Z"
                            fill="white"
                          />
                          <path
                            d="M165.091 51.6063H166.091V53.2721H166.996C167.358 53.2594 167.718 53.3132 168.06 53.4307C168.311 53.5164 168.539 53.6574 168.727 53.8432C168.892 54.0183 169.012 54.2306 169.076 54.4619C169.153 54.6865 169.191 54.9226 169.188 55.1599C169.185 55.4085 169.142 55.6549 169.06 55.8897C168.989 56.1253 168.858 56.3384 168.679 56.5084C168.486 56.7112 168.246 56.8637 167.981 56.9526C167.629 57.0745 167.258 57.1336 166.885 57.1271H165.107L165.091 51.6063ZM166.075 54.1922V56.207H166.79C167.153 56.2433 167.517 56.1537 167.822 55.9531C167.925 55.8598 168.006 55.7441 168.059 55.615C168.111 55.4858 168.133 55.3465 168.124 55.2075C168.134 55.066 168.113 54.924 168.061 54.792C168.008 54.6601 167.927 54.5418 167.822 54.446C167.522 54.249 167.163 54.1595 166.806 54.1922H166.075ZM170.22 51.6063H171.204V57.1271H170.22V51.6063Z"
                            fill="white"
                          />
                          <path
                            d="M175.904 54.2715L178 57.1271H176.793L175.174 54.8902L173.538 57.1271H172.395L174.475 54.3191L172.522 51.6063H173.713L175.206 53.6845L176.73 51.6063H177.873L175.904 54.2715Z"
                            fill="white"
                          />
                          <path
                            d="M89.7941 63.9328H86.7931V68.5334H85.8086V63.0127H90.7786V68.5334H89.7941V63.9328Z"
                            fill="white"
                          />
                          <path
                            d="M96.336 64.0122H94.3988V64.9323C94.363 65.5754 94.2619 66.2133 94.0971 66.836C94.011 67.2332 93.8493 67.6102 93.6207 67.9465C93.4647 68.1892 93.2373 68.3776 92.9697 68.4859C92.7136 68.5703 92.4455 68.6131 92.1758 68.6128V67.6609C92.3014 67.6879 92.4313 67.6879 92.5569 67.6609C92.7235 67.561 92.8605 67.4187 92.9538 67.2485C93.1144 66.9716 93.2322 66.6721 93.3032 66.3601C93.4382 65.8416 93.5128 65.3092 93.5255 64.7736L93.6207 63.0603H97.4634V68.581H96.4789L96.336 64.0122Z"
                            fill="white"
                          />
                          <path
                            d="M99.1146 63.4093C99.3737 63.2435 99.6579 63.1203 99.9562 63.0445C100.281 62.9482 100.618 62.9001 100.957 62.9017C101.248 62.8742 101.543 62.9127 101.817 63.0143C102.092 63.1159 102.341 63.2781 102.544 63.4887C102.889 63.9732 103.057 64.5611 103.021 65.1544V68.5335H102.1V67.8354C101.918 68.064 101.691 68.253 101.433 68.3907C101.095 68.565 100.717 68.6471 100.337 68.6287C99.8871 68.6468 99.4479 68.4872 99.1146 68.1845C98.9463 68.0212 98.8163 67.8227 98.7339 67.6033C98.6515 67.3838 98.6189 67.1489 98.6382 66.9153C98.6297 66.6576 98.6842 66.4017 98.797 66.1697C98.8998 65.9569 99.0523 65.7719 99.2416 65.6303C99.4307 65.4681 99.6528 65.349 99.8926 65.2813C100.166 65.2033 100.45 65.1659 100.734 65.1703C100.969 65.1758 101.203 65.2023 101.433 65.2496C101.671 65.2936 101.898 65.3853 102.1 65.5193C102.117 65.2869 102.117 65.0536 102.1 64.8212C102.085 64.6273 102.031 64.4383 101.941 64.266C101.846 64.1188 101.715 63.9985 101.56 63.917C101.351 63.8205 101.122 63.777 100.893 63.7901C100.608 63.7803 100.324 63.8178 100.051 63.9011C99.8173 63.9799 99.5891 64.0753 99.3686 64.1867L99.1146 63.4093ZM100.702 67.7403C101.014 67.7498 101.322 67.673 101.592 67.5182C101.793 67.3791 101.974 67.2137 102.132 67.0264V66.3283C101.766 66.0824 101.334 65.955 100.893 65.9635C100.751 65.9404 100.606 65.9404 100.464 65.9635C100.33 65.997 100.202 66.0505 100.083 66.1221C99.9737 66.1968 99.8816 66.2942 99.8132 66.4077C99.7481 66.5296 99.7153 66.6661 99.718 66.8043C99.7114 66.9222 99.7308 67.0401 99.7747 67.1497C99.8185 67.2593 99.8859 67.358 99.972 67.4388C100.176 67.6091 100.437 67.6944 100.702 67.6768"
                            fill="white"
                          />
                          <path
                            d="M104.021 63.0127H109.055V63.9963H107.022V68.5334H106.053V63.9963H104.021V63.0127Z"
                            fill="white"
                          />
                          <path
                            d="M114.596 67.9465C114.321 68.1926 113.996 68.3765 113.644 68.4859C113.285 68.6045 112.91 68.6635 112.532 68.6604C112.115 68.6698 111.7 68.5998 111.31 68.4542C110.958 68.3372 110.638 68.1419 110.373 67.8831C110.109 67.6253 109.908 67.3105 109.785 66.963C109.643 66.5882 109.573 66.1898 109.579 65.789C109.568 65.4061 109.628 65.0245 109.753 64.6626C109.871 64.32 110.061 64.0064 110.309 63.7425C110.562 63.4803 110.864 63.2701 111.198 63.1238C111.587 62.9701 112.003 62.8946 112.421 62.9017C112.764 62.9004 113.103 62.965 113.421 63.0921C113.726 63.1978 114.003 63.3713 114.231 63.5997C114.461 63.827 114.644 64.0963 114.771 64.3929C114.913 64.7181 114.983 65.0697 114.978 65.4241C115.004 65.6454 115.004 65.8691 114.978 66.0904H110.674C110.683 66.3234 110.74 66.5522 110.841 66.7623C110.942 66.9725 111.085 67.1596 111.262 67.312C111.642 67.6082 112.114 67.76 112.596 67.7403C112.931 67.7482 113.265 67.6945 113.58 67.5817C113.843 67.491 114.085 67.351 114.295 67.1692L114.596 67.9465ZM112.373 63.8218C111.929 63.8015 111.492 63.9487 111.151 64.2343C110.853 64.5152 110.662 64.891 110.611 65.2972H113.961C113.963 65.0954 113.924 64.8953 113.844 64.7096C113.765 64.5239 113.648 64.3567 113.501 64.2184C113.191 63.9446 112.787 63.8023 112.373 63.8218Z"
                            fill="white"
                          />
                          <path
                            d="M115.454 63.0286H116.692L118.582 65.6779L116.565 68.5335H115.358L117.486 65.6779L115.454 63.0286ZM118.836 63.0286H119.82V68.5335H118.836V63.0286ZM121.17 65.6779L123.329 68.5335H122.107L120.058 65.6779L121.964 63.0286H123.218L121.17 65.6779Z"
                            fill="white"
                          />
                          <path
                            d="M128.76 67.9464C128.482 68.1962 128.151 68.3805 127.792 68.4858C127.434 68.6068 127.058 68.6658 126.68 68.6603C126.268 68.6704 125.859 68.6004 125.474 68.4541C125.122 68.3371 124.802 68.1418 124.537 67.883C124.273 67.6218 124.068 67.3084 123.933 66.9629C123.797 66.5865 123.727 66.1892 123.727 65.7889C123.722 65.405 123.786 65.0234 123.917 64.6625C124.035 64.3199 124.225 64.0063 124.473 63.7424C124.726 63.4802 125.028 63.27 125.362 63.1237C125.746 62.972 126.156 62.8966 126.569 62.9016C126.912 62.8974 127.252 62.9622 127.569 63.092C127.877 63.2012 128.159 63.3742 128.395 63.5996C128.625 63.8269 128.808 64.0962 128.935 64.3928C129.077 64.718 129.147 65.0696 129.141 65.424C129.168 65.6453 129.168 65.869 129.141 66.0903H124.807C124.808 66.3247 124.862 66.5557 124.963 66.7669C125.065 66.9781 125.212 67.1643 125.394 67.3119C125.774 67.6081 126.247 67.7599 126.728 67.7402C127.063 67.7471 127.397 67.6933 127.712 67.5816C127.971 67.4837 128.213 67.3443 128.427 67.1691L128.76 67.9464ZM126.522 63.8217C126.081 63.8007 125.65 63.9483 125.315 64.2342C125.011 64.5108 124.819 64.8888 124.775 65.2971H128.125C128.115 64.892 127.951 64.506 127.665 64.2183C127.351 63.9405 126.94 63.798 126.522 63.8217Z"
                            fill="white"
                          />
                          <path
                            d="M130.475 68.5493V63.0285H131.46V67.1374L134.635 63.0285H135.62V68.5493H134.635V64.4405L131.46 68.5493H130.475ZM132.174 60.2047C132.174 60.8551 132.539 61.1724 133.127 61.1724C133.714 61.1724 133.968 60.8551 134.016 60.2047H134.937C134.946 60.4387 134.902 60.6716 134.81 60.8869C134.727 61.09 134.603 61.2736 134.445 61.4263C134.28 61.5837 134.086 61.7076 133.873 61.7911C133.633 61.8758 133.381 61.9187 133.127 61.9181C132.852 61.9198 132.578 61.877 132.317 61.7911C132.102 61.7121 131.907 61.5876 131.745 61.4263C131.588 61.2736 131.463 61.09 131.38 60.8869C131.301 60.6684 131.263 60.437 131.269 60.2047H132.174Z"
                            fill="white"
                          />
                          <path
                            d="M21.6426 42.9921L10.4164 49.4647L0 67.5023L42.4913 42.9921H21.6426Z"
                            fill="#874691"
                          />
                          <path
                            d="M53.7174 24.5103L42.4911 30.9829L32.0747 49.0205L74.5502 24.5103H53.7174Z"
                            fill="#DA1844"
                          />
                          <path
                            d="M42.4911 18.0376L32.0747 0V36.9795V49.0205V86L42.4911 67.9624V18.0376Z"
                            fill="#F9B229"
                          />
                          <path
                            d="M32.0747 0L42.4911 18.0376L53.7174 24.5102H74.5502L32.0747 0Z"
                            fill="#F07F1A"
                          />
                          <path
                            d="M32.0747 36.9795V86L42.4911 67.9623V55.0013L32.0747 36.9795Z"
                            fill="#72B22C"
                          />
                          <path
                            d="M53.7174 61.4897L42.4911 67.9624L32.0747 86L74.5502 61.4897H53.7174Z"
                            fill="#00743E"
                          />
                          <path
                            d="M0 18.4818V67.5023L10.4164 49.4647V36.5194L0 18.4818Z"
                            fill="#5F5A94"
                          />
                          <path
                            d="M32.0749 36.9795V36.9954L0 18.4818L10.4164 36.5194L53.7176 61.4897H74.5504L32.0749 36.9795Z"
                            fill="#0D90CD"
                          />
                          <path
                            d="M159.136 21.1311V43.1982H151.387V27.6989H143.908V43.1982H136.16V21.1311H159.136Z"
                            fill="white"
                          />
                          <path
                            d="M132.333 32.8707C132.444 39.2164 127.268 43.8329 119.932 43.8329C112.977 43.8329 107.118 39.6289 107.118 29.3964C107.118 20.7028 112.675 13.5322 120.884 13.4053H132.333L128.697 19.9414H121.71C119.98 19.8853 118.291 20.4697 116.966 21.5824C115.641 22.6951 114.775 24.2576 114.533 25.9697C116.739 24.0801 119.567 23.074 122.472 23.1459C125.062 23.1853 127.538 24.2188 129.385 26.0323C131.233 27.8458 132.311 30.3002 132.397 32.8865M124.648 33.3942C124.658 32.7842 124.547 32.1781 124.32 31.6116C124.093 31.0452 123.755 30.5296 123.327 30.0952C122.898 29.6608 122.386 29.3164 121.822 29.082C121.259 28.8475 120.654 28.7279 120.043 28.7301C119.413 28.7149 118.787 28.8276 118.202 29.0614C117.617 29.2952 117.086 29.6452 116.641 30.0902C116.195 30.5352 115.845 31.066 115.611 31.6503C115.377 32.2346 115.264 32.8602 115.279 33.4894C115.303 34.6813 115.785 35.8185 116.624 36.6658C117.463 37.5132 118.596 38.006 119.789 38.0424C120.406 38.0593 121.02 37.953 121.595 37.7298C122.17 37.5066 122.695 37.1709 123.139 36.7424C123.582 36.3139 123.936 35.8013 124.179 35.2345C124.421 34.6678 124.548 34.0583 124.552 33.4418"
                            fill="white"
                          />
                          <path
                            d="M101.419 35.6628C99.5871 36.7752 97.4817 37.3574 95.3377 37.3444C93.9756 37.2993 92.6838 36.7289 91.7335 35.7528C90.7832 34.7768 90.2481 33.4709 90.2407 32.1092C90.2483 30.7449 90.7855 29.4368 91.7392 28.4603C92.6929 27.4838 93.9887 26.9151 95.3536 26.874C97.494 26.8504 99.5972 27.4335 101.419 28.5556L104.309 23.3522C101.871 21.4657 98.8658 20.4593 95.7823 20.4966C88.2082 20.4966 83 26.6519 83 32.1092C83 38.4549 88.7798 43.8012 95.703 43.8329C98.8158 43.8863 101.853 42.873 104.309 40.9615L101.419 35.6628Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2_14384">
                            <rect width="178" height="86" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </g>
                    <defs>
                      <clipPath id="clip0_2_14384">
                        <rect width="178" height="86" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span>СБП #2</span>
              </div>
              <svg
                className="arrow-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 6l6 6-6 6"
                  stroke="#E1E1E1"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
			<button className="invest-method-btn" onClick={handlePAYEERClick}>
			  <div
				className="left"
				style={{ display: "flex", alignItems: "center" }}
			  >
				<span
				  style={{
					width: 14,
					height: 14,
					display: "flex",
					alignItems: "center",
					marginRight: 8,
				  }}
				>
				  <img
					src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAATlBMVEUBqfUApPQAp/VAtfbU7f3O6vy23/tevvcAo/T////C5fzd8f2h1/oAoPQtsfam2fpJufdXvPfp9v78//94x/g3s/YSq/VhwviJ0vpqxfjhyXfuAAAAgklEQVR4Ac3RtQHAMAwEQDNjOPsPGu7y7v0uzySJdBz6hiHjQt5R2vyNafvFGYheKXdpoAhDpCZdyhDm64i5zpYW0mxtZQ2M3tqE3zQmWDsYhOM43rVU1qxz1JQgdNM0VcMIxGBwa1+ks04tzIsuaxNL2njCIxMT3esKHyX3Z+7VcU7OGgZFJm19pAAAAABJRU5ErkJggg=="
					alt="PAYEER"
					style={{ width: "100%", height: "100%", display: "block" }}
					loading="lazy"
					decoding="async"
				  />
				</span>
				<span>PAYEER</span>
			  </div>
			  <svg
				className="arrow-icon"
				width="16"
				height="16"
				viewBox="0 0 24 24"
				fill="none"
			  >
				<path
				  d="M9 6l6 6-6 6"
				  stroke="#E1E1E1"
				  strokeWidth="2"
				  strokeLinecap="round"
				  strokeLinejoin="round"
				/>
			  </svg>
			</button>

            <button
              className="invest-method-btn"
              onClick={() => {
                handleOpenCryptoModal();
              }}
            >
              <div className="left">
                <svg
                  className="invest-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_crypto"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                  >
                    <rect width="16" height="16" fill="url(#pattern_crypto)" />
                  </mask>
                  <g mask="url(#mask0_crypto)">
                    <rect width="16" height="16" fill="#C0BBD9" />
                  </g>
                  <defs>
                    <pattern
                      id="pattern_crypto"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        xlinkHref="#image_crypto"
                        transform="scale(0.00195312)"
                      />
                    </pattern>
                    <image
                      id="image_crypto"
                      width="512"
                      height="512"
                      xlinkHref="data:image/png;base64,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"
                    />
                  </defs>
                </svg>
                <span>Криптовалюта</span>
              </div>
              <svg
                className="arrow-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9 6l6 6-6 6"
                  stroke="#E1E1E1"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
	</>
  );
}

export default CardPage;






